import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface PermissionGuardProps {
  allowed: boolean;
  children: React.ReactNode;
  message?: string;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  allowed,
  children,
  message = "Access denied",
}) => {
  if (allowed) return <>{children}</>;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-not-allowed">
          <span className="pointer-events-none opacity-50 select-none">
            {children}
          </span>
        </span>
      </TooltipTrigger>
      <TooltipContent>{message}</TooltipContent>
    </Tooltip>
  );
};
